import { useCallback } from "react";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { ocCurrentUserState } from "oc/states";

export const useOcCurrentUserState = () => {
  const setocCurrentUserState = useSetRecoilState(ocCurrentUserState);
  const data = useRecoilValue(ocCurrentUserState);
  const setData = useCallback(
    (value: Partial<typeof data>) =>
      setocCurrentUserState((prevState: typeof data) =>
        Object.assign({}, prevState, value),
      ),
    [setocCurrentUserState]
  );
  return { ...data, setData };
};

export default useOcCurrentUserState;
